function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { success_message, error_message } from "../../components/Toastr";
import { UploadFileDragger } from "../../components/Core";
import { Api_v2 } from "../../services/api";
import userImportTemplate from "../../assets/Flowy_User__IMPORT_MODEL.xlsx";
import userImportTutorial from "../../assets/user_import_tutorial.png";
import { ContentModal } from "./styles";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var FormImportUser = function FormImportUser() {
    var _useTranslation = useTranslation(), t = _useTranslation.t;
    var _useState = useState(), _useState2 = _slicedToArray(_useState, 2), importLogs = _useState2[0], setImportLogs = _useState2[1];
    var preStyle = {
        overflow: "auto",
        maxHeight: "400px"
    };
    return /*#__PURE__*/ _jsxs(ContentModal, {
        children: [/*#__PURE__*/ _jsx(UploadFileDragger, {
                accept: ".xlsx",
                customRequest: function customRequest(options) {
                    if (options.file instanceof File) {
                        Api_v2.User.importFromFile(options.file, true).then(function (r) {
                            var _r = _slicedToArray(r, 2), response = _r[0], err = _r[1];
                            if (err) {
                                var messages = err.notifications.map(function (e) {
                                    return e.message;
                                });
                                var errMesage = "Error while importing. Check error logs";
                                if (options.onError)
                                    options.onError(Error(errMesage));
                                error_message("Error while importing. Check error logs");
                                setImportLogs("Error logs:\n" + messages.join("\n"));
                            }
                            else {
                                if (response) {
                                    if (options.onSuccess)
                                        options.onSuccess(response, response.request);
                                    success_message(t("Prompt.Save"));
                                    setImportLogs(undefined);
                                }
                            }
                        })["catch"](function (err) {
                            if (options.onError)
                                options.onError(err);
                            console.error(err);
                            error_message(err.message);
                        });
                    }
                },
                children: t("ExcelFile")
            }), /*#__PURE__*/ _jsx("a", {
                style: {
                    display: "block",
                    marginTop: 15
                },
                href: userImportTemplate,
                target: "_blank",
                children: t("TemplateLink")
            }), /*#__PURE__*/ _jsx("a", {
                style: {
                    display: "block"
                },
                href: userImportTutorial,
                target: "_blank",
                children: t("HowToUse")
            }), /*#__PURE__*/ _jsx("pre", {
                style: preStyle,
                children: importLogs
            })]
    });
};
